import { render, staticRenderFns } from "./DefaultValue.vue?vue&type=template&id=3bf69728"
import script from "./DefaultValue.vue?vue&type=script&lang=js"
export * from "./DefaultValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports